import UserDropdown from "@components/userDropdown/UserDropdown"
import { CDN_URL, LOGOS_PATH } from "@utils/cdn"
import { ReactElement } from "react"

export type MapHeaderCompanyProps = {
	width?: number
}

export type MapHeaderProps = {
	width?: number
}

export default function MapHeader({ width }: MapHeaderProps): ReactElement {
	return (
		<div
			className="grid h-24 grid-cols-[225px_auto] pl-4"
			style={{ width: width !== undefined ? width : "100%" }}
		>
			<div className="flex h-24 items-center">
				<img
					className="max-h-1/2"
					alt={"DIPAI AS"}
					src={`${CDN_URL}/${LOGOS_PATH}/dipai_logo.svg`}
				/>
			</div>
			<div className="my-auto flex justify-end">
				<UserDropdown />
			</div>
		</div>
	)
}
